import { PropsWithChildren } from 'react'
import { useAutoAnimate } from '@formkit/auto-animate/react'
import { cn } from '../../utils'

interface ReorderingListProps {
  className?: string
}

export function ReorderingList({ children, className = '' }: PropsWithChildren<ReorderingListProps>) {
  const [parent] = useAutoAnimate({
    duration: 200,
    easing: 'ease-in-out',
  })

  return (
    <div ref={parent} className={cn('flex flex-col', className)}>
      {children}
    </div>
  )
}
